import { useTooltipWithHotkey } from '@app/core/hotkeys/useTooltipWithHotkey';
import { streamHotkeys } from '@app/modules/logger/screens/stream/stream-hotkeys';
import { Menu } from '@mi-front/ui';
import {
  Add as AddIcon,
  Close as CloseIcon,
  PauseRounded as PauseIcon,
  PlayArrowRounded as PlayIcon,
} from '@mui/icons-material';
import noop from 'lodash/noop';

interface Props {
  readonly loadingAudio: boolean;
  readonly play: null | (() => void);
  readonly pause: null | (() => void);
  readonly addChunk: null | (() => void);
  readonly clear: () => void;
}

export function SelectionMenuEditorP(p: Props) {
  const { play, addChunk, clear } = p;

  return (
    <Menu
      data-testid="selection-menu"
      className="el-selection-menu"
      actions={[
        {
          icon: <PlayIcon />,
          onClick: play || noop,
          tooltip: useTooltipWithHotkey(
            {
              id: 'logger.streamScreen.selectionMenu.play',
              defaultMessage: 'Reproducir selección',
            },
            streamHotkeys.get('playback', 'PLAY_PAUSE'),
          ),
          enabled: !!play,
          loading: p.loadingAudio,
        },
        {
          icon: <PauseIcon />,
          onClick: p.pause || noop,
          tooltip: useTooltipWithHotkey(
            {
              id: 'logger.streamScreen.cursorMenu.pause',
              defaultMessage: 'Pausar',
            },
            streamHotkeys.get('playback', 'PLAY_PAUSE'),
          ),
          enabled: !!p.pause,
          loading: p.loadingAudio,
        },
        {
          icon: <AddIcon fontSize="small" />,
          onClick: addChunk || noop,
          tooltip: useTooltipWithHotkey(
            {
              id: 'logger.streamScreen.selectionMenu.addChunk',
              defaultMessage: 'Agregar segmento al fragmento',
            },
            streamHotkeys.get('selection', 'ADD_CHUNK_FROM_FOCUS_SELECTION'),
          ),
          btnProps: {
            'data-testid': 'add-chunk-menu-btn',
            disabled: !addChunk,
          },
        },
        {
          icon: <CloseIcon fontSize="small" />,
          onClick: clear,
          tooltip: useTooltipWithHotkey(
            {
              id: 'logger.streamScreen.selectionMenu.unselect',
              defaultMessage: 'Deseleccionar',
            },
            streamHotkeys.get('selection', 'CLEAR_SELECTION'),
          ),
        },
      ]}
    />
  );
}
